import {
  convertExampleToCodegenInput,
  convertScenarioToCodegenInput,
  Endpoint,
} from '@square/ignition';
import { SpecificationVersionInfo } from '@squareup/dex-types-oas-path';

function parseEndpointTag(raw: string): {
  method: string;
  path: string;
} | null {
  const trimmed = raw.trim();
  const idx = trimmed.indexOf(' ');
  if (idx <= 0) {
    return null;
  }
  return {
    method: trimmed.slice(0, idx).toUpperCase(),
    path: trimmed.slice(idx + 1).trim(),
  };
}

function specOptionsFor(api?: string): SpecificationVersionInfo {
  // "latest" is the implicit default in our OAS hooks (omit version);
  // any other value is treated as a published square_version.
  const isLatest = !api || api === 'latest';
  return {
    grammar: 'open-api-3',
    namespace: 'square',
    version: isLatest ? undefined : api,
    isUnpublished: false,
  };
}

// Pick the codegen input for the requested example. Fern's example names
// don't always exist on our spec; when the name misses, prefer the first
// scenario (deterministic) over the endpoint's default to avoid silently
// swapping a populated body for an empty one.
function resolveCodegenInput(
  endpoint: Endpoint,
  exampleName?: string
): ReturnType<typeof convertExampleToCodegenInput> {
  const scenarios = endpoint.exampleScenarios || [];
  const namedScenario =
    exampleName && scenarios.find((s) => s.name === exampleName);
  const scenario = namedScenario || scenarios[0];
  if (scenario) {
    return convertScenarioToCodegenInput(scenario, endpoint);
  }
  return convertExampleToCodegenInput(endpoint);
}

export { parseEndpointTag, specOptionsFor, resolveCodegenInput };
